import { render } from "./UpdateKnowledgeBaseDialog.vue?vue&type=template&id=a0c9b55a&scoped=true"
import script from "./UpdateKnowledgeBaseDialog.vue?vue&type=script&lang=js"
export * from "./UpdateKnowledgeBaseDialog.vue?vue&type=script&lang=js"

import "./UpdateKnowledgeBaseDialog.vue?vue&type=style&index=0&id=a0c9b55a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0c9b55a"]])

export default __exports__